import Coordinator from "../../../../../public/coordinator.svg";
import Experts from "../../../../../public/experts.svg";
import Vendors from "../../../../../public/vendors.svg";

export const experts = [
  {
    Icon: Coordinator,
    title: "Home coordinator",
    description:
      "Your go-to-point of contact manages all of your projects — big and small."
  },
  {
    Icon: Experts,
    title: "Local experts",
    description:
      "Your on-the-ground support manages vendors, timelines, and budgets."
  },
  {
    Icon: Vendors,
    title: "Pre-vetted vendors",
    description:
      "Our pre-vetted vendor network covers all of your homes needs and allows us to offer you guaranteed pricing and project timelines."
  }
];
